<template>
  <div v-if="!disabled" class="form-floating" :class="'mb-'+mb">
    <textarea
        class="form-control form-control-solid"
        autocomplete="off"
        :placeholder="placeholder"
        :disabled="disabled"
        :autofocus="autofocus"
        :required="required"
        :value="modelValue"
        :class="[hasError ? 'is-invalid' : '', this.class]"
        :name="name"
        :id=id
        @input="updateValue"
    ></textarea>
    <label :for=id :class="{ required: required }" v-html="placeholder"></label>
    <slot></slot>
  </div>
  <disabled-field v-else :value="modelValue" :mb="mb" :placeholder="placeholder" :required="required"/>
</template>

<script>
import DisabledField from '@/components/Fields/DisabledField'

export default {
  name: 'AreaField',
  components: {DisabledField},
  props: {
    placeholder: null,
    modelValue: '',
    autofocus: false,
    required: false,
    hasError: false,
    disabled: null,
    class: null,
    type: null,
    name: null,
    mb:null,
    id:null
  },
  methods: {
    updateValue(event) {
      this.$emit('update:modelValue', event.target.value)
    }
  }
}
</script>

<style scoped>

</style>